import qs from 'querystring'
 
import _ from 'underscore'

import Api from '../lib/request'
import COOKIECONSTANT from '../constant/cookie'
import COMMONCONSTANT from '../constant/common'
import cookie from '../lib/cookie'

const config = () => {
  const platformType = cookie(COOKIECONSTANT.COOKIE_CO) === COOKIECONSTANT.COOKIE_CO_IS_SDYXVIP
    ? COMMONCONSTANT.COMMON_PLATFORM_IS_WECHAT_SDYX_VIP : COMMONCONSTANT.COMMON_PLATFORM_IS_WECHAT_SDYX
  return new Promise((resolve, reject) => {
    Api.get(`${COOKIECONSTANT.REQUEST_HOST}?url=${encodeURIComponent((window.location.href.split('#')[0]))}&platformType=${platformType}`, {
      headers: {
        'X-Host': 'mall.wechat.authority.config'
      }
    }).then((data) => {
      resolve(data.data)
    })
  })
}

const getWechatOpenId = () => {
  const platformType = cookie(COOKIECONSTANT.COOKIE_CO) === COOKIECONSTANT.COOKIE_CO_IS_SDYXVIP
    ? COMMONCONSTANT.COMMON_PLATFORM_IS_WECHAT_SDYX_VIP : COMMONCONSTANT.COMMON_PLATFORM_IS_WECHAT_SDYX
    return new Promise((resolve, reject) => {
      Api.get(`${COOKIECONSTANT.REQUEST_HOST}?platformType=${platformType}`, {
        headers: {
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
          'X-Host': 'mall.third-user.openid'
        }
      }).then((data) => {
        if (data.status === 0) {
          resolve(data.data)
        } else {
          reject(data)
        }
      })
    })
}

export default {
  config,
  getWechatOpenId,
}
